import React from 'react';
import { cx } from './cx';

// DESIGN.md: §4 radius-md, §3 control density (12/6), §1.3 body type,
// §6 named transitions at --dur-fast, §11 focus ring.
//
// Never write a bare `transition` (§9.2) — the properties are named, and they
// are the only ones this button changes.
const BASE = [
  'inline-flex items-center justify-center gap-space-2',
  'rounded-radius-md px-space-5 py-space-3',
  'text-body font-semibold',
  'transition-[background-color,border-color,color] duration-fast ease-standard',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent',
  'disabled:cursor-not-allowed',
].join(' ');

// Every filled variant carries carbon-950 text. The semantic roles are all
// light enough that dark text is the pairing that clears 4.5:1 — white on
// accent is only 3.40 — and dark-on-saturated is the broadcast register anyway.
//
// `primary` presses to accent-deep, which is dark enough that the text has to
// invert with it: carbon-950 on accent-deep is 3.57, carbon-050 is 5.15. The
// swap lasts as long as the mouse is down.
const VARIANTS = {
  primary:
    'bg-accent text-carbon-950 hover:bg-accent/90 active:bg-accent-deep active:text-carbon-050 disabled:bg-carbon-700 disabled:text-carbon-500',
  secondary:
    'bg-carbon-700 text-carbon-100 hover:bg-carbon-600 disabled:bg-carbon-800 disabled:text-carbon-500',
  ghost:
    'bg-transparent text-carbon-300 hover:bg-carbon-800 hover:text-carbon-050 disabled:text-carbon-600',
  danger:
    'bg-danger text-carbon-950 hover:bg-danger/90 disabled:bg-carbon-700 disabled:text-carbon-500',
  live:
    'bg-live text-carbon-950 hover:bg-live/90 disabled:bg-carbon-700 disabled:text-carbon-500',
};

export default function Button({ variant = 'primary', className, type = 'button', ...rest }) {
  return <button type={type} className={cx(BASE, VARIANTS[variant], className)} {...rest} />;
}
